<template>
    <frontPage/>
  <div>
    <input v-model="ipfsCID" placeholder="Enter your submission">
    <br>
    <div @click="executeTransaction">Execute Transaction</div>
    <div v-if="userAddress">
      Connected Address: {{ userAddress }}
    </div>
  </div>
</template>


<script>
import { ethers } from 'ethers';
import abi from './assets/StorageContract.json';
import frontPage from './frontPage.vue';



export default {
    components: {
    frontPage
  },
    data() {
        return {
            provider: null,
            signer: null,
            userAddress: null,
            ipfsCID: ''
        };
    },
    methods: {
        async connectWallet() {
            if (window.ethereum) {
                this.provider = new ethers.providers.Web3Provider(window.ethereum);
                try {
                    // Request account access if needed
                    await this.provider.send("eth_requestAccounts", []);
                    this.signer = this.provider.getSigner();
                    this.userAddress = await this.signer.getAddress();
                    console.log('Connected Address:', this.userAddress);
                } catch (error) {
                    console.error('User denied account access', error);
                }
            } else {
                console.error('No Ethereum provider was found. Please install MetaMask.');
            }
        },
        async executeTransaction() {
    if (!window.ethereum) {
        console.error('No Ethereum provider found. Please install MetaMask.');
        return;
    }

    const provider = new ethers.providers.Web3Provider(window.ethereum);
    const signer = provider.getSigner();
    //const contractAddress = "0x8aF1C13eE07CBff274429B3EaeF6E8158c2a0F0F";
    const contractAddress = "0xd0F350b13465B5251bb03E4bbf9Fa1DbC4a378F3";
    const contract = new ethers.Contract(contractAddress, abi, signer);

    try {
        const txResponse = await contract.addSubmission(this.ipfsCID, await signer.getAddress());
        await txResponse.wait();
        console.log('Transaction completed!');
    } catch (error) {
        console.error('Transaction failed:', error);
    }
}
    },
    mounted() {
        this.connectWallet();
    }
};
</script>
